module.exports = __webpack_public_path__ + "static/media/loader.b0a23662.gif";